import { Component, Inject, OnInit } from '@angular/core';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GestoresResiduosControllerService, MotivosBajaGestoresControllerService, MotivosBajaGestoresDTO } from 'api-rest';
import { SnackbarService } from '../../../services/snackbar.service';
import { SpinnerService } from '../../../services/spinner.service';

@Component({
  selector: 'lib-waste-managers-baja-motivo-dialog',
  templateUrl: './waste-managers-baja-motivo-dialog.component.html',
  styleUrls: ['./waste-managers-baja-motivo-dialog.component.scss'],
})
export class WasteManagersBajaMotivoDialogComponent implements OnInit {
  motivosBaja: MotivosBajaGestoresDTO[] = [];
  gestores: any[] = [];

  formGroup!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<WasteManagersBajaMotivoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private motivosBajaGestoresControllerService: MotivosBajaGestoresControllerService,
    private gestoresResiduosControllerService: GestoresResiduosControllerService,
    private snackBarSrv: SnackbarService,
    public spinnerSrv: SpinnerService
  ) {
    this.gestores = this.data?.gestores ?? [];

    this.formGroup = this.formBuilder.group({
      motivoBaja: [
        { value: null, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      observacionesBaja: [{ value: null, disabled: false }],
    });
  }

  ngOnInit(): void {
    this.cargarMotivosBaja();
  }

  cargarMotivosBaja(): void {
    this.motivosBajaGestoresControllerService.findAll11().subscribe({
      next: (data: any) => {
        this.motivosBaja = data!;
      },
      error: () => {},
    });
  }

  guardar() {
    this.formGroup.markAllAsTouched();
    this.formGroup.updateValueAndValidity();

    if (this.formGroup.valid) {
      const motivoBaja = this.formGroup.get('motivoBaja')?.value;
      const observacionesBaja = this.formGroup.get('observacionesBaja')?.value;

      this.spinnerSrv.loadingShow();

      forkJoin(
        this.gestores.map((gestor: any) =>
          this.gestoresResiduosControllerService.editById4(gestor.id, {
            ...gestor,
            motivoBaja,
            observacionesBaja,
          } as any)
        )
      ).subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.dialogRef.close({ motivoBaja, observacionesBaja });
        },
        error: (err: { message: any }) => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Ha ocurrido un error al guardar el motivo de baja',
            'error'
          );
        },
      });
    } else {
      this.snackBarSrv.showSnackBar(
        'Debe completar los campos obligatorios',
        'error'
      );
    }
  }

  cerrar(): void {
    this.dialogRef.close(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.formGroup.controls[controlName].hasError(errorName) &&
      this.formGroup.controls[controlName].touched
    );
  }
}
